import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../../../components/SettingsBreadcrumb';
import './inserir-modelo-5.scss';
import BibliotecaModal from '../../BibliotecaModal/BibliotecaModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Image,
  IconButton,
  Select,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  VStack,
} from '@chakra-ui/react'
import * as api from '../../../../../../api/outrasPaginas';
import Swal from 'sweetalert2';
import { FaEye, FaGripVertical, FaImage, FaMinus, FaPlus, FaTimes } from 'react-icons/fa';
import QuillEditor from '../../../../../../components/common/QuillEditor';
import {
  DragDropContext as RBDDragDropContext,
  Droppable as RBDDroppable,
  Draggable as RBDDraggable,
  DropResult,
} from 'react-beautiful-dnd';

const DragDropContext = RBDDragDropContext as any;
const Droppable = RBDDroppable as any;
const Draggable = RBDDraggable as any;

interface Imagem {
  id: number;
  imagem: string;
  imagemPreview: string;
  tipo?: 'image' | 'video';
}

interface Secao {
  id: number;
  titulo: string;
  descricao: string;
  aberto: boolean;
  imagem: Imagem[];
}

const InserirPaginaModelo5: React.FC = () => {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    dscUrl: { value: string; error: boolean };
    tituloSelecao: { value: string; error: boolean };
  }>({
    titulo: { value: '', error: false },
    dscUrl: { value: '', error: false },
    tituloSelecao: { value: '', error: false },
  });

  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [submitAttempted, setSubmitAttempted] = useState<boolean>(false);
  const [bibliotecaOpen, setBibliotecaOpen] = useState<boolean>(false);
  const [secaoAtualId, setSecaoAtualId] = useState<number | null>(null);

  const [selecao, setSelecao] = useState<Secao[]>([
    {
      id: 1,
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: []
    },
  ]);

  const {
    isOpen: isPreviewAberto,
    onOpen: onPreviewAberto,
    onClose: onPreviewFechado
  } = useDisclosure()

  const videoExts = ['.mp4', '.webm', '.ogg'];

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    const updatedSelecao = Array.from(selecao);
    const [movedItem] = updatedSelecao.splice(result.source.index, 1);
    updatedSelecao.splice(result.destination.index, 0, movedItem);
    setSelecao(updatedSelecao);
  };

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const isFormValid = () => {
    const { titulo, dscUrl } = formValues;
    if (!titulo.value.trim() || !dscUrl.value.trim()) return false;
    const isValido =
      selecao.length > 0 &&
      selecao.every((secao) => secao.titulo.trim() !== "" && secao.descricao.trim() !== "");
    return isValido;
  };

  const formataData = (date: Date) => {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  const abrirBlibliotecaDeFotos = (secaoId: number) => {
    setSecaoAtualId(secaoId);
    setBibliotecaOpen(true);
  };

  const handleSelectImageFromBiblioteca = (media: any) => {
    if (secaoAtualId === null) return;

    const url = decodeURIComponent(media.dscUriCdn || media.dscMidia);
    const limpar = url.split('?')[0].toLowerCase();

    const isVideo = videoExts.some(ext => limpar.endsWith(ext));

    const novaImagem: Imagem = {
      id: Date.now(),
      imagem: url,
      imagemPreview: url,
      tipo: isVideo ? 'video' : 'image'
    };

    setSelecao(prev =>
      prev.map(secao =>
        secao.id === secaoAtualId
          ? { ...secao, imagem: [...secao.imagem, novaImagem] }
          : secao
      )
    );

    setBibliotecaOpen(false);
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitAttempted(true);
    setLoadingButton(true);

    try {
      const updatedSelecao = selecao.map(secao => ({
        ...secao,
        imagem: secao.imagem.map(img => {
          return {
            id: img.id,
            url: img.imagem,
          };
        })
      }));

      const jsonModeloData = {
        codModeloPagina: 5,
        tituloGeral: formValues.titulo.value,
        secoes: selecao.map((secao, index) => ({
          id: secao.id,
          titulo: secao.titulo,
          descricao: secao.descricao,
          aberto: secao.aberto,
          imagem: updatedSelecao.find(s => s.id === secao.id)?.imagem || [],
          ordem: index + 1,
        }))
      };

      const params = {
        nomPagina: formValues.titulo.value || null,
        dscUrl: formValues.dscUrl.value || null,
        datRegistro: formataData(new Date()),
        txtHtml: null,
        numHtmlProprio: 0,
        numBloqueada: 0,
        sitRegistro: 1,
        datInativo: null,
        codModeloPagina: 5,
        jsonModelo: JSON.stringify(jsonModeloData)
      };

      await api.inserirPagina(params);
      setLoadingButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Página inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente/outras-paginas');
      });
    } catch (error) {
      console.error('Erro ao inserir página:', error);
      if (typeof error === 'string' && error.includes('Erro ao atualizar a Pagina')) {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'O nome da página já está em uso. Por favor, escolha outro.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'Erro ao inserir página. Tente novamente mais tarde.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
      }
      setLoadingButton(false);
    }
  };

  const handleAddSelecao = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const novaSelecao: Secao = {
      id: Date.now(),
      titulo: '',
      descricao: '',
      aberto: true,
      imagem: []
    };
    setSelecao(prevSelecao => [...prevSelecao, novaSelecao]);
  };

  const handleRemoverSelecao = (id: number) => {
    setSelecao(prevSelecao => prevSelecao.filter(secao => secao.id !== id));
  };

  const toggleSelecao = (id: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === id ? { ...secao, aberto: !secao.aberto } : secao
      )
    );
  };

  const handleRemoveImagem = (secaoId: number, imgId: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === secaoId
          ? { ...secao, imagem: secao.imagem.filter(img => img.id !== imgId) }
          : secao
      )
    );
  };

  const handleSelecaoChange = (id: number, field: string, value: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === id ? { ...secao, [field]: value } : secao
      )
    );
  };

  const carregarPreview = () => (
    <Box position="relative" maxW="1200px" mx="auto" py={10}>
      <Box
        position="absolute"
        top={0}
        bottom={0}
        left="50%"
        transform="translateX(-50%)"
        w="4px"
        bg="#d3d3d3"
        zIndex={0}
      />

      <VStack spacing={20} align="stretch" position="relative" zIndex={1}>
        {selecao.map((secao, idx) => {
          const img = secao.imagem[0];
          const isPar = idx % 2 === 0;
          const isVideo = img?.imagemPreview?.endsWith('.mp4');

          return (
            <Flex
              key={secao.id}
              align="flex-start"
              justify="space-between"
              flexDirection={['column', isPar ? 'row' : 'row-reverse']}
              gap={[6, 10]}
              position="relative"
            >

              <Box
                position="absolute"
                top="24px"
                left="50%"
                transform="translateX(-50%)"
                w="20px"
                h="20px"
                bg="white"
                border="4px solid #ccc"
                borderRadius="full"
                zIndex={2}
              />

              {isVideo ? (
                <Box
                  as="video"
                  w="140px"
                  h="140px"
                  borderRadius="full"
                  border="4px solid white"
                  boxShadow="lg"
                  zIndex={3}
                  autoPlay
                  muted
                  loop
                  objectFit="cover"
                  src={img?.imagemPreview}
                  ml={isPar ? ['0', 'calc(50% - 200px + 10px)'] : 'auto'}
                  mr={isPar ? 'auto' : ['0', 'calc(50% - 200px + 10px)']}
                />
              ) : (
                <Box
                  w="140px"
                  h="140px"
                  bgImage={`url('${img?.imagemPreview}')`}
                  bgSize="cover"
                  bgPosition="center"
                  borderRadius="full"
                  border="4px solid white"
                  boxShadow="lg"
                  zIndex={3}
                  ml={isPar ? ['0', 'calc(50% - 200px + 10px)'] : 'auto'}
                  mr={isPar ? 'auto' : ['0', 'calc(50% - 200px + 10px)']}
                />
              )}
              <Box
                minW={'500px'}
                maxW={'500px'}
                p={6}
                bg="white"
                borderRadius="xl"
                boxShadow="lg"
                textAlign="left"
                ml={isPar ? ['0', 'calc(50% - 600px + 12px)'] : 'auto'}
                mr={isPar ? 'auto' : ['0', 'calc(50% - 600px + 12px)']}
              >
                <Heading as="h3" fontSize="xl" mb={2}>
                  {secao.titulo}
                </Heading>
                <Text
                  fontSize="md"
                  lineHeight="1.6"
                  textAlign="justify"
                  dangerouslySetInnerHTML={{ __html: secao.descricao }}
                />
              </Box>
            </Flex>

          );
        })}
      </VStack>
    </Box>
  );

  return (
    <Flex direction="column" padding="40px" backgroundColor="#fafafa" width="100%" height="100%" overflow="hidden">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Modelo 5 - Linha do Tempo
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row mb-3">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Título Geral</FormLabel>
                <CustomInput
                  placeholder="Digite um título"
                  value={formValues.titulo.value}
                  maxLength={100}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                />
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.dscUrl.error}>
                <FormLabel mb="8px">URL da Página</FormLabel>
                <CustomInput
                  placeholder="Digite uma URL"
                  value={formValues.dscUrl.value}
                  onChange={(e) => handleFieldChange('dscUrl', e.target.value)}
                  maxLength={512}
                />
              </FormControl>
            </div>
          </div>

          <Box mb="20px">
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="secoes">
                {(provided: any) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {selecao.map((secao, index) => {
                      const secaoErro =
                        !secao.aberto &&
                        submitAttempted &&
                        secao.imagem.some(img => img.imagem);
                      return (
                        <Draggable key={secao.id.toString()} draggableId={secao.id.toString()} index={index}>
                          {(providedDraggable: any) => (
                            <Box
                              ref={providedDraggable.innerRef}
                              {...providedDraggable.draggableProps}
                              borderWidth="1px"
                              borderRadius="md"
                              p="20px"
                              mb="10px"
                              borderColor={secaoErro ? 'red.500' : 'gray.200'}
                            >
                              <Flex justifyContent="space-between" alignItems="center" mb="10px">
                                <Flex
                                  alignItems="center"
                                  {...providedDraggable.dragHandleProps}
                                  cursor="grab"
                                >
                                  <FaGripVertical style={{ marginRight: '8px' }} />
                                  <Heading as="h5" size="sm">
                                    {secao.titulo || `Seção ${index + 1}`}
                                  </Heading>
                                </Flex>
                                <Flex>
                                  <Button variant="ghost" size="xs" onClick={() => toggleSelecao(secao.id)} mr="2">
                                    {secao.aberto ? <FaMinus /> : <FaPlus />}
                                  </Button>
                                  <Button variant="ghost" size="xs" colorScheme="red" onClick={() => handleRemoverSelecao(secao.id)}>
                                    <FaTimes />
                                  </Button>
                                </Flex>
                              </Flex>
                              {secao.aberto && (
                                <Box>
                                  <FormControl mb="10px" isRequired>
                                    <FormLabel>Título</FormLabel>
                                    <CustomInput
                                      value={secao.titulo}
                                      onChange={(e) => handleSelecaoChange(secao.id, 'titulo', e.target.value)}
                                      placeholder="Digite o título da seção"
                                    />
                                  </FormControl>

                                  <FormControl mb="10px">
                                    <FormLabel>Mídia da Seção</FormLabel>
                                    <Flex wrap="wrap" gap="20px">
                                      {secao.imagem.map(img => {
                                        const isVideo = img.tipo === 'video';

                                        return (
                                          <Box
                                            key={img.id}
                                            borderWidth="1px"
                                            borderRadius="md"
                                            p="10px"
                                            bg="#FFF"
                                            boxShadow="md"
                                            position="relative"
                                          >
                                            <Box
                                              w="150px"
                                              h="100px"
                                              bg="#f0f0f0"
                                              borderRadius="4px"
                                              overflow="hidden"
                                              mx="auto"
                                            >
                                              {isVideo ? (
                                                <video
                                                  src={img.imagemPreview}
                                                  controls
                                                  muted
                                                  playsInline
                                                  style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                    display: 'block'
                                                  }}
                                                  onClick={e => e.stopPropagation()}
                                                />
                                              ) : (
                                                <Image
                                                  src={img.imagemPreview}
                                                  alt="Preview da mídia"
                                                  w="100%"
                                                  h="100%"
                                                  objectFit="contain"
                                                  display="block"
                                                  onClick={e => e.stopPropagation()}
                                                />
                                              )}
                                            </Box>

                                            <IconButton
                                              icon={<FaTimes />}
                                              size="xs"
                                              colorScheme="red"
                                              position="absolute"
                                              top="2"
                                              right="2"
                                              borderRadius="full"
                                              aria-label="Remover mídia"
                                              onClick={e => {
                                                e.stopPropagation();
                                                handleRemoveImagem(secao.id, img.id);
                                              }}
                                            />
                                          </Box>
                                        );
                                      })}
                                      {secao.imagem.length === 0 && (
                                        <Button variant="outline" onClick={() => abrirBlibliotecaDeFotos(secao.id)}>
                                          <FaImage color="gray" size="15px" />
                                          <Text pl="6px" mt="4px" fontSize="sm">Adicionar Mídia</Text>
                                        </Button>
                                      )}
                                    </Flex>
                                  </FormControl>

                                  <FormControl mb="10px" isRequired>
                                    <FormLabel>Descrição</FormLabel>
                                    <QuillEditor
                                      value={secao.descricao || ''}
                                      placeholder="Digite a descrição da seção"
                                      onChange={(content: string) =>
                                        handleSelecaoChange(secao.id, 'descricao', content)
                                      }
                                    />
                                  </FormControl>
                                </Box>
                              )}
                            </Box>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            <Button onClick={handleAddSelecao} _hover={{ opacity: 0.8 }} leftIcon={<FaPlus />} bgColor="#1665D8" color="#FFF">
              Adicionar Seção
            </Button>
          </Box>

          <Flex mt="35px" justifyContent="end">
            <Button m="6px" onClick={() => navigate('/cms/edicao-cidade-inteligente/outras-paginas/inserir-pagina')}>
              Desistir
            </Button>
            <Button
              mt="6px"
              leftIcon={<FaEye />}
              variant="outline"
              onClick={onPreviewAberto}
            >
              Ver Preview
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Inserindo..."
            >
              Inserir Página Modelo
            </Button>
          </Flex>
        </form>
      </Box>
      <BibliotecaModal
        isOpen={bibliotecaOpen}
        onClose={() => setBibliotecaOpen(false)}
        onSelectImage={handleSelectImageFromBiblioteca}
      />

      <Modal isOpen={isPreviewAberto} onClose={onPreviewFechado} size="full" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={'#004a7f'} fontWeight={'bold'}>{formValues.titulo.value}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {carregarPreview()}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onPreviewFechado}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

    </Flex>
  );
};

export default InserirPaginaModelo5;